module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "block_114",
    attrs: {
      "id": "id_Toc176537616"
    }
  }, [_vm._v("Chapter 6")]), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_4"
  }), _vm._v(" "), _c('p', {
    staticClass: "block_9"
  }, [_vm._v("The return from a fantastic tour of Australasia brought Steven down to earth. He was back at Seaford House and commuting from his pad in Kensington. Coordinator was a different sort of role with more politics than he would have liked. The continual baiting by the Secretary, despite Steven being able to outsmart and out vote him, was wearying. It was only when Steven had cause to review and update the College personnel hand-out with Penny, the commandant’s secretary, that she queried the secretary’s medals and post-nominals, the letters after his title. She was a stickler for accuracy in all she did: she had to be.")]), _vm._v(" "), _c('p', {
    staticClass: "block_7"
  }, [_c('span', {
    staticClass: "text_1"
  }, [_vm._v("His two “Mentioned in Dispatches” was at odds with the campaign medals attached. She said he couldn’t have been in both war theatres three thousand miles apart, and still have been full-time on the general staff in London. She asked Steven to clarify the “mistake,” which he did by pretending to the Secretary that there appeared to be a typo on his CV with clashing dates and suggested that the error may have come from a mix up with the senior directing staff’s army major general. The Secretary looked flustered, and Steven volunteered to double-check, but the defeatist shrug ended the game. Steven nodded knowingly, and the battle was won, so to speak, with a rather subdued retired major general.")]), _c('br', {
    staticClass: "calibre4",
    attrs: {
      "id": "calibre_pb_13"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76159ffe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/index_split_006.vue
// module id = 81
// module chunks = 0